import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Header from "../../components/header/Header";
import "./LegalPages.scss";

class TermsOfService extends Component {
  gotoHome = () => {
    this.props.history.push("/");
  };

  scrollTo = (section) => {
    this.props.history.push({
      pathname: "/",
      state: {
        section,
      },
    });
  };

  render() {
    return (
      <section className="legal-page">
        <Header
          theme="light"
          scrollTo={this.scrollTo}
          logoAction={this.gotoHome}
        />
        <div className="legal-main">
          <div className="max-container">
          <h1>Terms of Service</h1>
          <p className="effective-date">
            <strong>Effective Date:</strong> January 2024
          </p>

          <section>
            <h2>Agreement to Terms</h2>
            <p>
              By accessing or using the SCI-Trade platform operated by
              Co-creation Hub (CcHUB), you agree to be bound by these Terms of
              Service.
            </p>
          </section>

          <section>
            <h2>Description of Service</h2>
            <p>SCI-Trade provides:</p>
            <ul>
              <li>Trade opportunity data across African countries</li>
              <li>Commodity and product analysis under AfCFTA</li>
              <li>Country-specific trade insights</li>
              <li>COPI (Commodity Opportunity Index) rankings</li>
              <li>POPI (Product Opportunity Index) analysis</li>
              <li>Downloadable trade reports</li>
            </ul>
          </section>

          <section>
            <h2>User Accounts</h2>
            <h3>Registration</h3>
            <ul>
              <li>You must provide accurate and complete information</li>
              <li>You are responsible for maintaining account security</li>
              <li>One account per user or organization</li>
            </ul>
          </section>

          <section>
            <h2>Acceptable Use</h2>
            <h3>Permitted Uses</h3>
            <ul>
              <li>Access trade data for legitimate business purposes</li>
              <li>Generate reports for internal use</li>
              <li>Share insights in compliance with these terms</li>
            </ul>

            <h3>Prohibited Uses</h3>
            <ul>
              <li>Unauthorized data scraping or automated access</li>
              <li>Reselling or redistributing platform data</li>
              <li>Interfering with platform functionality</li>
              <li>Violating intellectual property rights</li>
            </ul>
          </section>

          <section>
            <h2>Payment Terms</h2>
            <h3>Premium Features</h3>
            <ul>
              <li>Some features require payment through Flutterwave</li>
              <li>Prices are displayed in applicable currency</li>
              <li>Payments are processed securely</li>
            </ul>
          </section>

          <section>
            <h2>Intellectual Property</h2>
            <h3>Platform Content</h3>
            <ul>
              <li>Trade data, analysis, and reports are proprietary</li>
              <li>Platform design and functionality are protected</li>
              <li>Users receive limited license for personal/business use</li>
            </ul>
          </section>

          <section>
            <h2>Open Source License</h2>
            <p>
              This platform is licensed under GNU General Public License v3
              (GPLv3):
            </p>
            <ul>
              <li>You may use, modify, and distribute the software</li>
              <li>Modifications must also be licensed under GPLv3</li>
              <li>Source code is available at: https://github.com/cchub/sci</li>
            </ul>
          </section>

          <section>
            <h2>Disclaimers</h2>
            <h3>Information Accuracy</h3>
            <ul>
              <li>Trade data is provided "as is"</li>
              <li>We strive for accuracy but cannot guarantee completeness</li>
              <li>Users should verify information independently</li>
            </ul>
          </section>

          <section>
            <h2>Contact Information</h2>
            <p>
              For questions about these terms, contact Co-creation Hub (CcHUB).
            </p>
          </section>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(TermsOfService);
